import { API, ENDPOINTS } from '@/app/services/api-url';
import { lowercase, capitalize } from '@/app/filters/filters';

export const ToolkitApi = {
  getItemType(type) {
    const words = type.split('_');
    return {
      type,
      key: words
        .map((word, idx) => {
          if (idx > 0) {
            return capitalize(word);
          }
          return lowercase(word);
        })
        .join(''),
    };
  },
  preparePayload(item) {
    const itemKey = this.getItemType(item.type);
    let { type } = item;
    if (type === 'RENT_RELIEF') {
      type = 'COVID';
    }
    const payload = {
      accountID: item.accountID,
      relation: item.relation,
      cognitoID: item.cognitoID,
      status: item.status,
      fundName: item.fundName,
      fund: item.fund,
      data: item.data,
      type,
    };
    if (itemKey.type === 'PENSION_ESTABLISHMENT') {
      payload.nextAction = item.data.setup.part;
    }
    return payload;
  },
  saveItem(item) {
    const endpoint = item.uuid
      ? `${ENDPOINTS.POST_TOOLKIT}/${item.uuid}`
      : ENDPOINTS.POST_TOOLKIT;
    return API.post(endpoint, this.preparePayload(item));
  },
  getItem(item) {
    const endpoint = `${ENDPOINTS.GET_TOOLKIT_ITEM}/${item.uuid}?accountID=${
      item.relation
    }&type=${item.type}`;
    return API.get(endpoint);
  },
};

export { ToolkitApi as default };
